import React from 'react'
import './Electronic.css'
import Electronicimage1 from "../Departmentimage/IMG_1283 (FILEminimizer).JPG"
const Electronic = () => {
  return (
    <div className='main-container-electronic'>
        <img src={Electronicimage1} className="Electronicimage1" alt='iamge' />
       
      
        <div className='container-electronic'>
        
        <div data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1000">
          <h1>ELECTRONICS & COMUNICATION ENGINEERING</h1> <hr />
          </div>
          <div className='electronic'>
          <div data-aos="fade-right">
              <p>
              Electronics & Communication Engineering Department offers  Diploma & 
              undergraduate program in Electronics Engineering.  The department has highly 
              qualified and competent faculty members in the area of digital Signal Processing, 
              Active circuits,<br /> Data 
            Communications,High Speed Network, Instrumentation and 
              Control,   Optical Network and VLSI & Micro - Electronics. On Completion of the 
              programme students would possess deep understanding of analog & digital system 
              design, digital & analog communication, microwave engineering, computer system 
              and good knowledge of VLSI Design & Control System
              </p>
              </div>
              <div data-aos="fade-left">
              <p>
              Fully equipped with the latest and measuring instruments including oscilloscope, 
              Logic scope, Clock generator, Function generator, Analog & Digital IC Tester etc. 
              Good range of TTL & CMOS IC to perform a wide range of experiments in digital 
              electronics. Fully functional at the breadboard level designing.   <br />
              <ul>
                <li>Basic Electronics Lab</li>
                <li>Analog Electronics Lab</li>
                <li>Digital Electronics Lab</li>
                <li>Electronic Measurement & Instrumentation La</li>
                <li>Power Electronics Lab</li>
                <li>N/W Filter & Transmission lines Lab etc.</li>
               </ul>           
              </p>
              </div>
              
          </div> 
          
        </div> <hr />
    </div>
  )
}

export default Electronic
